/**
 * Kinds of actions a compact list header can render.
 * Built-in kinds are rendered by `DataTable` with its own handlers; `Custom` renders consumer-provided content.
 */
export const enum ListHeaderActionTypeEnum {
    Refresh = 'refresh',
    ColumnsChooser = 'columnsChooser',
    ManageLabels = 'manageLabels',
    SaveFilters = 'saveFilters',
    SavedFilters = 'savedFilters',
    Search = 'search',
    Custom = 'custom',
}

/**
 * Where a list header action is rendered: inline in the title row, or collapsed into the three-dot menu.
 */
export const enum ListHeaderActionPlacementEnum {
    Header = 'header',
    Menu = 'menu',
}
